import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import React from 'react';
import { brand } from 'themes/brand';

export const TERMINAL_STATUSES = ['DELIVERED', 'READ', 'FAILED', 'UNDELIVERED'];
export const POLLING_INTERVAL_MS = 2500;
export const POLLING_MAX_ATTEMPTS = 3;

export const STATUS_META: Record<
  string,
  { label: string; color: string; Icon: React.ElementType }
> = {
  QUEUED: { label: 'Aguardando envio', color: '#d97706', Icon: AccessTimeIcon },
  SENT: { label: 'Enviada', color: brand.glow, Icon: CheckIcon },
  DELIVERED: { label: 'Entregue', color: brand.primary, Icon: DoneAllIcon },
  READ: { label: 'Lida', color: '#16a34a', Icon: DoneAllIcon },
  FAILED: { label: 'Falha no envio', color: '#dc2626', Icon: WarningAmberIcon },
  UNDELIVERED: {
    label: 'Falha no envio',
    color: '#dc2626',
    Icon: WarningAmberIcon,
  },
  SENDING: { label: 'Enviando...', color: '#9ca3af', Icon: AccessTimeIcon },
};
